import { useState, useCallback } from 'react';

type ConfirmationOptions = {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  severity?: 'info' | 'warning' | 'error';
};

type ConfirmationState = ConfirmationOptions & {
  resolve: (value: boolean) => void;
};

export function useConfirmation() {
  const [confirmationState, setConfirmationState] = useState<ConfirmationState | null>(null);

  const confirm = useCallback(
    (options: ConfirmationOptions): Promise<boolean> => {
      return new Promise<boolean>((resolve) => {
        setConfirmationState({
          ...options,
          resolve,
        });
      });
    },
    []
  );

  const handleConfirm = useCallback(() => {
    if (confirmationState) {
      confirmationState.resolve(true);
      setConfirmationState(null);
    }
  }, [confirmationState]);

  const handleCancel = useCallback(() => {
    if (confirmationState) {
      confirmationState.resolve(false);
      setConfirmationState(null);
    }
  }, [confirmationState]);

  return {
    isOpen: !!confirmationState,
    confirmationState,
    confirm,
    handleConfirm,
    handleCancel,
  };
}

export default useConfirmation;